<template>
    <div class="body-card-border-primary container">
        <h2 class="pull-center">Registración</h2>

        <hr>

        <div class="row">
            <div class="col-sm-6">
                <h3><strong>Creá tu cuenta gratis</strong></h3>

                <p>Analizá indicadores económicos claves de Argentina</p>

                <ul>
                    <li>Comparar índices de inflación, tasas de plazo fijo y el histórico de la evolución del dólar</li>
                    <li>Configurar notificaciones personalizadas de acuerdo al canal que prefieras</li>
                    <li>Informar sobre más de 10 tipos de cambio actualizados al momento</li>
                    <li>Analizar la variación desde la apertura del mercado para cada tipo de cambio</li>
                    <li>Configurar tipos de cambio favoritos y ordenarlos de acuerdo a tu conveniencia</li>
                </ul>
            </div>

            <div class="col-sm-6">
                <form>
                    <b-overlay :show="showOverlay" rounded="sm">
                        <div class="row">
                            <div class="col-sm-6 margin-bottom">
                                <label>Nombre</label>

                                <input type="text"
                                        :class="[errorNameRequired ? 'is-invalid' : '', 'form-control']"
                                        minlength="6"
                                        maxlength="30"
                                        placeholder="Ingresá el Nombre"
                                        v-model="user.name">

                                <small v-if="errorNameRequired">Es un campo requerido</small>
                            </div>
                            
                            <div class="col-sm-6 margin-bottom">
                                <label>Apellido</label>

                                <input type="text"
                                        :class="[errorLastNameRequired ? 'is-invalid' : '', 'form-control']"
                                        maxlength="30"
                                        placeholder="Ingresá el Apellido"
                                        v-model="user.lastName">
                                        
                                <small v-if="errorLastNameRequired">Es un campo requerido</small>
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div>
                                <label>Número de celular</label>

                                <!-- <input type="text"
                                        :class="[errorCellPhoneRequired ? 'is-invalid' : '', 'form-control input-border-shadow']"
                                        maxlength="15" 
                                        placeholder="+549"
                                        v-model="user.cellPhone"> -->

                                <input type="text"
                                    class="form-control"
                                    maxlength="15" 
                                    placeholder="+549"
                                    v-model="user.cellPhone">
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div>
                                <label>Fecha de nacimiento</label>
                            </div>

                            <div class="col-sm-6">
                                <input
                                    type="date"
                                    class="p-2"
                                    :class="[errorBirthDateRequired ? 'is-invalid' : '', 'col-12 input-border-shadow']"
                                    placeholder="Ingresá la Fecha de nacimiento" 
                                    v-model="user.birthDate">
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div>
                                <label>Sexo</label>
                            </div>

                            <div>
                                <b-form-select v-model="genderSelected" class="form-control">
                                    <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                    <b-form-select-option v-for="gender in genders" :key="gender.id" :value=gender.id>
                                        {{ gender.name }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div>
                                <label>País</label>
                            </div>

                            <div>
                                <b-form-select 
                                    v-model="countrySelected"
                                    :class="[errorCountryIdRequired ? 'is-invalid' : '', 'form-control']">
                                    <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                    <b-form-select-option v-for="country in countries" :key="country.id" :value=country.id>
                                        {{ country.name }}
                                    </b-form-select-option>
                                </b-form-select>

                                <small v-if="errorCountryIdRequired">Es un campo requerido</small>
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div>
                                <label>Industria</label>
                            </div>

                            <div>
                                <b-form-select
                                    v-model="industrySelected"
                                    :class="[errorIndustryIdRequired ? 'is-invalid' : '', 'form-control']">
                                    <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                    <b-form-select-option v-for="industry in industries" :key="industry.id" :value=industry.id>
                                        {{ industry.name }}
                                    </b-form-select-option>
                                </b-form-select>

                                <small v-if="errorIndustryIdRequired">Es un campo requerido</small>
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div class="col-sm-12">
                                <label>Email</label>
                            </div>

                            <div>
                                <input 
                                    type="email"
                                    :class="[errorEmailRequired || invalidEmail ? 'is-invalid' : '', 'form-control']"
                                    maxlength="30"
                                    placeholder="Ingresá el Email"
                                    v-model="user.email" />
                                
                                <!-- <b-icon id="infoIcon" class="color-yellow margin-left margin-bottom" icon="exclamation-circle"/> -->

                                <!-- <b-tooltip 
                                    target="infoIcon"
                                    triggers="hover">
                                    Por favor, es importante que ingreses un correo electrónico valido debido a que te va a llegar un correo de verificación
                                </b-tooltip> -->

                                <small v-if="errorEmailRequired">Es un campo requerido</small>
                                <small v-if="!errorEmailRequired && invalidEmail">Formato de email inválido</small>
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div class="col-sm-12">
                                <label>Contraseña</label>

                                <input type="password"
                                        :class="[errorPasswordRequired || invalidPassword ? 'is-invalid' : '', 'form-control']"
                                        minlength="6"
                                        maxlength="16"
                                        placeholder="Ingresá la Contraseña"
                                        v-model="user.password">
                            </div>
                        </div>

                        <div class="row margin-bottom">
                            <div class="col-sm-12">
                                <label>Confirmar contraseña</label>

                                <input type="password"
                                        :class="[errorPasswordRequired || invalidPassword || passwordHasDifference ? 'is-invalid' : '', 'form-control']"
                                        minlength="6"
                                        maxlength="16"
                                        placeholder="Repetí la Contraseña"
                                        v-model="user.passwordValidation">

                                <small v-if="errorPasswordRequired">Es un campo requerido</small>
                                <small v-if="!errorPasswordRequired && invalidPassword">La longitud debe ser igual o mayor a 6</small>
                                <small v-if="!errorPasswordRequired 
                                    && !invalidPassword 
                                    && passwordHasDifference">
                                    Las contraseñas no coinciden</small>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-12 pull-right">
                                <a class="mx-3" href="/Login"><strong>Tengo una cuenta</strong></a>

                                <button class="btn-primary" type="button" v-on:click="postRegister()">Registrar</button>
                            </div>
                        </div>
                    </b-overlay>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/style.css"
import { mapActions } from "vuex"
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { GENDER_TYPES } from '@/enums/enums';
import API_ROUTES from '@/api/routes';


export default {
    components: {
        Datepicker
    },

    data() {
        return {
            showOverlay: false,
            es: es,
            // user: {
            //     name: "Facundo",
            //     lastName: "Espilocin", 
            //     cellPhone: "+541124644402", 
            //     birthDate: new Date(1994, 5, 15),
            //     countryId: 0, 
            //     industryId: 0,
            //     email: "facu.espilocin@hotmail.com", 
            //     password: "123456"
            // },
            user: {
                name: "",
                lastName: "", 
                cellPhone: "", 
                birthDate: new Date(2023, 3, 11),
                countryId: 0, 
                industryId: 0,
                email: "", 
                password: "",
                passwordValidation: "",
            },

            genders: GENDER_TYPES,
            genderSelected: null,

            countries: [],
            countrySelected: null,

            industries: [],
            industrySelected: null,

            errorNameRequired: false,
            errorLastNameRequired: false,
            // errorCellPhoneRequired: false,
            errorBirthDateRequired: false,
            errorCountryIdRequired: false,
            errorIndustryIdRequired: false,
            errorEmailRequired: false,
            errorPasswordRequired: false,

            invalidEmail: false,
            invalidPassword: false,
            passwordHasDifference: false,
        }
    },

    async created() { 
        await this.getCountries();
        await this.getIndustries();
    },

    methods: {
        ...mapActions(["setUser"]),

        async postRegister() {
            // console.log("User in context: ");
            // console.log(this.user);
            this.showOverlay = true;
            let isValid = this.validateFields();

            if (isValid) {
                this.$axios.post(API_ROUTES.POST_USER, this.user)
                .then(res => {
                    // console.log("Response: ");
                    // console.log(res.data?.errors);
                    if (res.data?.errors?.length >= 1) {
                        const errorMessages = res.data.errors.map(error => error.errorMessage);

                        this.showNotification("error", ...errorMessages);
                    } else {
                        window.location.href = "/Register/Success";
                    }
                })
                .catch(e => {
                    this.showNotification("error", e);
                })
                .finally(e => {
                    this.showOverlay = false;
                })
            } else {
                this.showOverlay = false;
            }
        },

        async getCountries() {
            this.$axios.get(API_ROUTES.GET_COUNTRIES)
            .then(res => {
                if (res.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                }

                this.countries = res.data;
                //this.countrySelected = this.countries[0].id;
            })
            .catch(e => {
                this.showNotification("error", e);
            })
        },

        async getIndustries() {
            this.$axios.get(API_ROUTES.GET_INDUSTRIES)
            .then(res => {
                if (res.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                }
                
                this.industries = res.data;
                //this.industrySelected = this.industries[0].id;
            })
            .catch(e => {
                this.showNotification("error", e);
            })
        },

        dateFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },

        validateFields() {
            let result = true;
            
            if (this.user.name === "") {
                this.errorNameRequired = true;
                result = false;
            }
            
            if (this.user.lastName === "") {
                this.errorLastNameRequired = true;
                result = false;
            }
            
            if (this.user.birthDate === "") {
                this.errorBirthDateRequired = true;
                result = false;
            }

            if (this.user.email === "") {
                this.errorEmailRequired = true;
                result = false;
            }

            if (this.user.countryId <= 0) {
                this.errorCountryIdRequired = true;
                result = false;
            }

            if (this.user.industryId <= 0) {
                this.errorIndustryIdRequired = true;
                result = false;
            }

            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(this.user.email)) {
                this.invalidEmail = true;
                result = false;
            } else {
                this.invalidEmail = false;
            }

            if (this.user.password === "" || this.user.passwordValidation === "") {
                this.errorPasswordRequired = true;
                result = false;
            } else if (this.user.password.length < 6 || this.user.passwordValidation.length < 6) {
                this.invalidPassword = true;
                result = false;
            } else if (this.user.password !== this.user.passwordValidation) {
                this.passwordHasDifference = true;
                result = false;
            } else {
                this.passwordHasDifference = false;
                this.errorPasswordRequired = false;
                this.invalidPassword = false;
            }
            
            return result;
        },
    },

    watch: {
        "countrySelected": function(newValue)
        {
            this.user.countryId = newValue;
        },

        "industrySelected": function(newValue)
        {
            this.user.industryId = newValue;
        },

        "genderSelected": function(newValue)
        {
            this.user.genderId = newValue;
        },

        "user.name": function() {
            this.user.name === "" ? this.errorNameRequired = true : this.errorNameRequired = false;
        },

        "user.lastName": function() {
            this.user.lastName === "" ? this.errorLastNameRequired = true : this.errorLastNameRequired = false;
        },

        // "user.cellPhone": function() {
        //     this.user.cellPhone === "" ? this.errorCellPhoneRequired = true : this.errorCellPhoneRequired = false;
        // },

        "user.birthDate": function() {
            this.user.birthDate === "" ? this.errorBirthDateRequired = true : this.errorBirthDateRequired = false;
        },

        "user.countryId": function() {
            this.user.countryId === "" ? this.errorCountryIdRequired = true : this.errorCountryIdRequired = false;
        },

        "user.industryId": function() {
            this.user.industryId === "" ? this.errorIndustryIdRequired = true : this.errorIndustryIdRequired = false;
        },

        "user.email": function() {
            this.user.email === "" ? this.errorEmailRequired = true : this.errorEmailRequired = false;
            
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(this.user.email)) {
                this.invalidEmail = true;
                result = false;
            } else {
                this.invalidEmail = false;
            }
        },

        "user.password": function() {
            this.user.password === "" ? this.errorPasswordRequired = true : this.errorPasswordRequired = false;

            // if (this.user.password !== this.user.passwordValidation) {
            //     this.passwordHasDifference = true;
            // } else {
            //     this.passwordHasDifference = false;
            // }

            if (this.user.password === "" || this.user.passwordValidation === "") {
                this.errorPasswordRequired = true;
            } else if (this.user.password.length < 6 || this.user.passwordValidation.length < 6) {
                this.invalidPassword = true;
            } else if (this.user.password !== this.user.passwordValidation) {
                this.passwordHasDifference = true;
            } else {
                this.passwordHasDifference = false;
                this.errorPasswordRequired = false;
                this.invalidPassword = false;
            }
        },

        "user.passwordValidation": function() {
            this.user.passwordValidation === "" ? this.errorPasswordRequired = true : this.errorPasswordRequired = false;

            // if (this.user.password !== this.user.passwordValidation) {
            //     this.passwordHasDifference = true;
            // } else {
            //     this.passwordHasDifference = false;
            // }

            if (this.user.password === "" || this.user.passwordValidation === "") {
                this.errorPasswordRequired = true;
            } else if (this.user.password.length < 6 || this.user.passwordValidation.length < 6) {
                this.invalidPassword = true;
            } else if (this.user.password !== this.user.passwordValidation) {
                this.passwordHasDifference = true;
            } else {
                this.passwordHasDifference = false;
                this.errorPasswordRequired = false;
                this.invalidPassword = false;
            }
        }
    },
}
</script>